/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateUserRequest } from '../models/CreateUserRequest';
import type { SystemUserDto } from '../models/SystemUserDto';
import type { UpdateUserRequest } from '../models/UpdateUserRequest';
import type { UsersUserDto } from '../models/UsersUserDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UsersService {

  /**
   * @returns SystemUserDto OK
   * @throws ApiError
   */
  public static listUsers(): CancelablePromise<Array<SystemUserDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/users',
    });
  }

  /**
   * @returns SystemUserDto OK
   * @throws ApiError
   */
  public static createUser({
    requestBody,
  }: {
    requestBody: CreateUserRequest,
  }): CancelablePromise<SystemUserDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/users',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns UsersUserDto OK
   * @throws ApiError
   */
  public static getCurrentUser(): CancelablePromise<UsersUserDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/users/me',
    });
  }

  /**
   * @returns SystemUserDto OK
   * @throws ApiError
   */
  public static updateUser({
    userId,
    requestBody,
  }: {
    userId: string,
    requestBody: UpdateUserRequest,
  }): CancelablePromise<SystemUserDto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v2/users/{userId}',
      path: {
        'userId': userId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static deleteUser({
    userId,
  }: {
    userId: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v2/users/{userId}',
      path: {
        'userId': userId,
      },
    });
  }

}
